import * as React from "react";
import { forwardRef, memo } from "react";
const SvgAt = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 9 6", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#ed2939", d: "M0 0h9v6H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M0 2h9v2H0z" }));
const ForwardRef = forwardRef(SvgAt);
const Memo = memo(ForwardRef);
export default Memo;
